import { render, staticRenderFns } from "./head_img.vue?vue&type=template&id=7f32f58e&scoped=true&"
import script from "./head_img.vue?vue&type=script&lang=js&"
export * from "./head_img.vue?vue&type=script&lang=js&"
import style0 from "./head_img.vue?vue&type=style&index=0&id=7f32f58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f32f58e",
  null
  
)

export default component.exports